import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-mb-case-timeline-skeleton',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './mb-case-time-line-skeleton.component.html',
  styleUrls: ['./mb-case-time-line-skeleton.component.css'],
})
export class MbCaseTimeLineSkeletonComponent {
}
